<script lang="ts" setup>
  import { TEST_ID } from './CounterButton.constants'

  interface Props {
    disabled?: boolean
  }

  withDefaults(defineProps<Props>(), {
    disabled: false,
  })

  interface Emits {
    (e: 'click'): void
  }
  const emit = defineEmits<Emits>()
  const onClick = () => {
    emit('click')
  }
</script>

<template>
  <div
    class="counter-button"
    :class="{ 'counter-button--disabled': disabled }"
    :data-testid="TEST_ID"
    @mousedown.prevent="onClick"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss">
  @import './CounterButton';
</style>
